export { MessagesForwardingItem as default };

/**
* Messages Forwarding Item
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesForwardingItem {
  /**
   * Forward Emails
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  forward_emails = {};

  /**
   * Forward Email Count
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  forward_email_count = 0;

  /**
   * Delivery Mode
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  forward_enabled = 0;

  /**
   * Keep Local Copy when Forwarding
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  keep_local_copy = 0;
}